var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "FiltersContainer",
        { attrs: { title: "Filters" }, on: { click: _vm.handleReset } },
        [
          [
            _c("FormGroup", {
              attrs: { title: "", placeholder: "", debounceTime: 500 },
              scopedSlots: _vm._u([
                {
                  key: "title",
                  fn: function () {
                    return [_c("p", { staticClass: "mb-2" }, [_vm._v(" Name")])]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.title,
                callback: function ($$v) {
                  _vm.title = $$v
                },
                expression: "title",
              },
            }),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [
                          _vm._v(" Contractors"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("ContractorsMultiselect", {
                  attrs: { contractorsConditions: _vm.contractorsWhere },
                  model: {
                    value: _vm.contractorsIds,
                    callback: function ($$v) {
                      _vm.contractorsIds = $$v
                    },
                    expression: "contractorsIds",
                  },
                }),
              ],
              1
            ),
            !_vm.hideManagersFilter
              ? _c(
                  "FormGroup",
                  {
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c("p", { staticClass: "mb-2" }, [
                                _vm._v("Managers"),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      1435854636
                    ),
                  },
                  [
                    _c("ManagersMultiselect", {
                      model: {
                        value: _vm.managersIds,
                        callback: function ($$v) {
                          _vm.managersIds = $$v
                        },
                        expression: "managersIds",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [
                          _vm._v(" Locations"),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("GroupLocationsMultiselect", {
                  model: {
                    value: _vm.locations,
                    callback: function ($$v) {
                      _vm.locations = $$v
                    },
                    expression: "locations",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [_vm._v(" Clients")]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("ProjectsMultiselect", {
                  attrs: { getcontainerStyle: "customWidthInput" },
                  model: {
                    value: _vm.projectsIds,
                    callback: function ($$v) {
                      _vm.projectsIds = $$v
                    },
                    expression: "projectsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [_vm._v("Postings")]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("PostingsMultiselect", {
                  attrs: { postingsConditions: _vm.postingsWhere },
                  model: {
                    value: _vm.postings,
                    callback: function ($$v) {
                      _vm.postings = $$v
                    },
                    expression: "postings",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [_vm._v(" Skills")]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("SkillsMultiselect", {
                  model: {
                    value: _vm.skillsIds,
                    callback: function ($$v) {
                      _vm.skillsIds = $$v
                    },
                    expression: "skillsIds",
                  },
                }),
              ],
              1
            ),
            _c(
              "FormGroup",
              {
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function () {
                      return [
                        _c("p", { staticClass: "mb-2" }, [_vm._v("Status")]),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              },
              [
                _c("RadioButtonGroup", {
                  attrs: {
                    options: _vm.radioStatusOptions,
                    name: "statusOptions",
                  },
                  model: {
                    value: _vm.postingStatus,
                    callback: function ($$v) {
                      _vm.postingStatus = $$v
                    },
                    expression: "postingStatus",
                  },
                }),
              ],
              1
            ),
          ],
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }